const anchors = document.querySelectorAll('a[href^="http"]');

anchors.forEach((anchor) => {
	const currentDomainHostname = window.location.hostname;
	const href = anchor.getAttribute('href');

	if (href && !href.includes(currentDomainHostname)) {
		if (anchor.hasAttribute('rel')) {
			const relValue = anchor.getAttribute('rel');
			if (!relValue.includes('noopener')) {
				anchor.setAttribute('rel', `${relValue} noopener`);
			}
		} else {
			anchor.setAttribute('rel', 'noopener');
		}
	}
});
